import { SortListAscending } from "app/utils/sort.util";
import { Actions } from "./actions";
import {
  ADD_PLANS_RESPONSE,
  DELETE_PLANS_RESPONSE,
  UPDATE_PLANS_RESPONSE,
  SET_PLANS_BY_ID,
  SET_PLAN_TEMPLATE_BY_ID,
  SET_PLANS_LIST,
  SET_MODULES_AND_FEATURES_LIST
} from "./actionTypes";
import { initialState, PlansState } from "./state";

export function PlansReducer(state = initialState, action: Actions): PlansState {
  switch (action.type) {
    case SET_PLANS_LIST:
      return Object.assign({}, state, {
        plansList: action.payload
      });
    case SET_MODULES_AND_FEATURES_LIST:
      return Object.assign({}, state, {
        modulesAndFeaturesList: action.payload
      });
    case SET_PLANS_BY_ID:
      return Object.assign({}, state, {
        planById: action.payload
      });
    case SET_PLAN_TEMPLATE_BY_ID:
      return Object.assign({}, state, {
        planTemplateById: action.payload
      });
    case ADD_PLANS_RESPONSE:
      return Object.assign({}, state, {
        addPlansResponse: action.payload
      });
    case UPDATE_PLANS_RESPONSE:
      return Object.assign({}, state, {
        updatePlansResponse: action.payload
      });
    case DELETE_PLANS_RESPONSE:
      return Object.assign({}, state, {
        deletePlansResponse: action.payload
      });
    default:
      return state;
  }
}
